import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const CataloguePropTypes = PropTypes.shape({
    _id: PropTypes.string,
    companyId: PropTypes.string,
    productId: PropTypes.string,
    // companyCommissionId: PropTypes.string,
    catalogueName: PropTypes.string,
});

export const CatalogueDefaultProps = {
    companyId: '',
    productId: '',
    // companyCommissionId: '',
    catalogueName: '',
};

export const CatalogueYupSchema = Yup.object().shape({
    companyId: Yup.string().required('Required'),
    productId: Yup.string().required('Required'),
    // companyCommissionId: Yup.string().required('Required'),
    catalogueName: Yup.string().required('Required'),
});

export default {
    CatalogueDefaultProps,
    CataloguePropTypes,
    CatalogueYupSchema,
};
